import React, { PropsWithChildren } from 'react'

import { Config } from '@flowwai-frontend/shared/constants'
import { FullScreenLoader } from '@flowwai-frontend/shared/common-components'
import { StatsigProvider, useClientAsyncInit } from '@statsig/react-bindings'

import { getDynamicFeatureTogglesTier } from '../../utils'

interface Props extends PropsWithChildren {}

const DynamicFeatureTogglesProvider = (props: Props): React.ReactElement => {
   const { children } = props

   const token = Config.STATS_IG_SECRET_TOKEN

   const { client } = useClientAsyncInit(
      token,
      {
         //NOTE: need to set user id on login and logout, which will be done later
      },
      {
         environment: {
            tier: getDynamicFeatureTogglesTier()
         }
      }
   )

   if (!token) {
      return <>{children}</>
   }

   return (
      <StatsigProvider client={client} loadingComponent={<FullScreenLoader />}>
         {children}
      </StatsigProvider>
   )
}

export default DynamicFeatureTogglesProvider
